import { IACDLEvent } from '../../../../../../../__legacy__/services/eventBus.service';

export const MarkingToolAddedEventType = Symbol('MARKING_TOOL_ADDED_EVENT');

export class MarkingToolAddedEvent implements IACDLEvent {
  readonly type: symbol = MarkingToolAddedEventType;
}
